import starFull from "../assets/star-icon-full.svg";
import starEmpty from "../assets/star-icon-empty.svg";
import plusIcon from "../assets/plus-icon.svg";
import type { Props2 } from "../Types";
import { sanitizeImageUrl } from "../imageUrl";


// Hotels Card Layout
const CardLayout2 = ({image, title, classification, region, introduction, href}: Props2) => {

    const introText = (text: string, maxLength: number) => {
        if (!text) return "";
        if (text.length <= maxLength) return text;
        const trimmed = text.substring(0, maxLength);
        const lastWord = trimmed.lastIndexOf(" ");
        return trimmed.substring(0, lastWord) + "...";  
    }

    const shortIntroText = introText(introduction || "", 90);

    // Hotel classification stars function logic
    const hotelStars = (classification: string) => {

        if (!classification) return "";

        // Extract number from classifiction value
        const numberMatch = classification.match(/[1-5]/);
        if (!numberMatch) {
            return <span>{classification}</span>
        }
        
        // Converts the extracted number string to an integer
        const numberStars = numberMatch ? Number(numberMatch[0]) : 0;

        // Check if classification value includes a plus 
        const hasPlus = (classification.toLowerCase().includes("plus"));

        // Created empty array to add the stars 
        const stars = [];
        // It adds the full star icon until the matched number 
        for (let i = 0; i < numberStars; i++) {
            stars.push(
                <img
                    src={starFull}
                    key={`full-star-${i}`}
                    alt="full star icon"
                    className="me-1" 
                />
            )
        }
        // It adds empty star if array index less than five
        for (let i = numberStars; i < 5; i++) {
            stars.push(
                <img 
                    src={starEmpty}
                    key={`empty-star-${i}`}
                    alt="empty star icon"
                    className="me-1"
                />
            )
        }
        // If there is "plus", it adds the plus icon
        if (hasPlus) {
            stars.push(
                <img 
                    src={plusIcon}
                    key="plus"
                    alt="plus icon"
                    className=""
                />
            )
        }
        return stars;
    }

    return (
    <>
        <div className="card rounded-0 border-0 shadow-0 h-100">
            <a href={href} className="text-decoration-none text-dark">

                {/* Image */}
                <div className="card-img">
                    <figure className="figure has-object-fit h-10rem">
                        <img data-object-fit="cover"
                            className=" ls-is-cached lazyloaded"
                            alt={title}
                            title={title}
                            src={sanitizeImageUrl(image, { width: 600 })}
                        />
                    </figure>
                </div>

                {/* Body Content */}
                <div className="card-body py-0 pb-4">
                    <div className="d-flex justify-content-between align-items-start gap-2">
                        <p className="h6 mb-1 me-2 flex-grow-1 item-heading text-strong mb-0">{title}</p><br/>
                        <span className="badge text-secondary">{hotelStars(classification)}</span>
                    </div>
                    <div className="fs-6 text-uppercase text-secondary pb-4">
                        <span>{region}</span>
                    </div>
                    <div className="mt-auto">
                        <span>{shortIntroText}</span>
                    </div>
                </div>
            </a>
        </div>
    </>
    )
}

export default CardLayout2